import { ManagerSales } from '@sorare/marketplace/src/components/market/ManagerSales';

import { SelectedLeaderboardBanner } from 'components/searchCards/SelectedLeaderboardBanner';

const ManagerSalesPage = () => {
  return <ManagerSales banner={<SelectedLeaderboardBanner />} />;
};

export default ManagerSalesPage;
